import * as React from "react";
import * as style from "./LearnMore.style";
import { IKImage } from "imagekitio-react";
import { hooks } from "../../../utility";
import { Button, Icon } from "../../../components";
import { Link } from "react-router-dom";
import dinnerCruise from "../../../../public/assets/dinner-cruise.jpg";
import sunsetCruise from "../../../../public/assets/sunset-cruise.jpg";
import hourlyCruise from "../../../../public/assets/hourly-cruise.jpg";
import krakenImage from "../../../../public/assets/kraken-on-water.jpeg";
import bacheloretteSandbar from "../../../../public/assets/bachelorette-boat-cruise-sandbar.jpeg";
import wildlifeImage from "../../../../public/assets/wildlife.jpeg";

const LearnMore: React.FC = () => {
  const display = hooks.useDisplayContext();
  return (
    <div className={style.component}>
      <div className={style.titleContainer}>
        <IKImage
          className={style.titleImage}
          alt="rehoboth bay water"
          path="/rehoboth-bay-water.png"
          height={display.isMobile ? 75 : 123}
        />
        <div className={style.title}>Learn More...</div>
      </div>
      <div className={style.contentContainer}>
        <div className={style.cruises}>
          <div className={style.cruise}>
            <div className={style.cruiseTitle}>The Octolounge</div>
            <div className={style.cruiseDetails}>
              Fast, flexible, and built for adventure! With a 250 HP motor, this
              is the fastest rental boat on the bay, perfect for sandbar trips,
              bar hopping and more. Ideal for bachelorette parties or any group
              looking for variety, yet still perfect for families who want a fun
              day exploring the bay.
            </div>
            <div className={style.imageContainer}>
              <img
                className={style.image}
                alt="dewey rehoboth beach hourly cruise"
                src={hourlyCruise}
              />
            </div>
            <Link to="/hourly" className={style.link}>
              <Button dark={true} rounded={false}>
                Dive In
              </Button>
            </Link>
          </div>
          <div className={style.cruise}>
            <div className={style.cruiseTitle}>The Kraken</div>
            <div className={style.cruiseDetails}>
              The only double-decker pontoon with a slide on the Bay! Perfect
              for swimming, sunbathing, and hanging out with friends.
            </div>
            <div className={style.imageContainer}>
              <img
                className={style.image}
                alt="kraken double decker pontoon boat"
                src={krakenImage}
              />
            </div>
            <Link to="/kraken" className={style.link}>
              <Button dark={true} rounded={false}>
                Dive In
              </Button>
            </Link>
          </div>
          <div className={style.cruise}>
            <div className={style.cruiseTitle}>Morning Mimosa Cruise</div>
            <div className={style.cruiseDetails}>
              Enjoy the calmness of the bay in the morning time. Drinks and
              breakfast are recommended!
            </div>
            <div className={style.imageContainer}>
              <IKImage
                className={style.image}
                alt="dewey bachelorette party booze cruise"
                path="/dewey-beach-bachelorette-party-booze-cruise.png"
              />
            </div>
            <Link to="/morning" className={style.link}>
              <Button dark={true} rounded={false}>
                Dive In
              </Button>
            </Link>
          </div>
          <div className={style.cruise}>
            <div className={style.cruiseTitle}>History &amp; Wildlife Tour</div>
            <div className={style.cruiseDetails}>
              Informational and educational tour along the Southern Delaware
              waterways with one of our local captains!
            </div>
            <div className={style.imageContainer}>
              <img
                className={style.image}
                alt="rehoboth bay wildlife tour"
                src={wildlifeImage}
              />
            </div>
            <div>
              <Link to="/history" className={style.link}>
                <Button dark={true} rounded={false}>
                  Dive In
                </Button>
              </Link>
            </div>
          </div>
          <div className={style.cruise}>
            <div className={style.cruiseTitle}>Sunset Cruise</div>
            <div className={style.cruiseDetails}>
              The sunset cruise is one of our most popular trips. Available on
              both the Octolounge and the Kraken, each offers a relaxed cruise
              through canals or along waterfront homes—with the option for a
              swim. For the best sunset view on the bay, nothing beats the
              Kraken's top deck.
            </div>
            <div className={style.imageContainer}>
              <img
                className={style.image}
                alt="dewey beach sunset bay cruise"
                src={sunsetCruise}
              />
            </div>
            <Link to="/sunset" className={style.link}>
              <Button dark={true} rounded={false}>
                Dive In
              </Button>
            </Link>
          </div>
          <div className={style.cruise}>
            <div className={style.cruiseTitle}>Dinner Cruise</div>
            <div className={style.cruiseDetails}>
              Enjoy a beautiful evening with friends, watching the sunset over
              the Rehoboth Beach waters
            </div>
            <div className={style.imageContainer}>
              <img
                className={style.image}
                style={{ maxHeight: 300 }}
                alt="dewey beach dinner cruise"
                src={dinnerCruise}
              />
            </div>
            <Link to="/dinner" className={style.link}>
              <Button dark={true} rounded={false}>
                Dive In
              </Button>
            </Link>
          </div>
          <div className={style.cruise}>
            <div className={style.cruiseTitle}>The Floatilla</div>
            <div className={style.cruiseDetails}>
              Why choose one when you can have both? Combine the Octolounge and
              the Kraken for the ultimate experience on the bay—perfect for big
              groups, up to 26 guests.
            </div>
            <div className={style.imageContainer}>
              <img
                className={style.image}
                alt="floatilla boat combo experience"
                src={bacheloretteSandbar}
              />
            </div>
            <Link to="/floatilla" className={style.link}>
              <Button dark={true} rounded={false}>
                Dive In
              </Button>
            </Link>
          </div>
        </div>
        {!display.isMobile && (
          <Icon.Squiggles
            className={style.squiggles}
            fill={"transparent"}
            width={display.windowWidth > 1400 ? 1400 : display.windowWidth}
            height={500}
          />
        )}
        {!display.isMobile && (
          <Icon.Squiggles
            className={style.squiggles2}
            fill={"transparent"}
            width={display.windowWidth > 1400 ? 1400 : display.windowWidth}
            height={500}
          />
        )}
        <div className={style.contentOverlay} />
      </div>
    </div>
  );
};

LearnMore.displayName = "LearnMore";
export { LearnMore };
